import * as Yup from 'yup';

export const acceptedMimeTypes = {
  XLSX: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  XLS: 'application/vnd.ms-excel',
};

export const validationSchema = Yup.object({
  companyId: Yup.string().required('חברה הוא שדה חובה'),
  phoneNumber: Yup.string().required('מספר טלפון הוא שדה חובה'),
  govId: Yup.string().required('מספר ת.ז הוא שדה חובה'),
});
